
const CurrencyData = {
    'EUR': '€',
    'GBP': '£',
    'CHF': 'CHF',
    'SEK': 'SEK',
    'NOK': 'NOK',
    'DKK': 'DKK',
    'USD': '$'
};

export {
    CurrencyData,
}


